module.exports = __webpack_public_path__ + "img/4.4977a3f6.png";